import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import PrivacyPage from './pages/PrivacyPage';

// Lazy load ContactPage for code splitting
const ContactPage = lazy(() => import('./pages/ContactPage'));
// お知らせ（一覧・記事）も初期バンドルから外す
const NewsPage = lazy(() => import('./pages/NewsPage'));
const NewsArticlePage = lazy(() => import('./pages/NewsArticlePage'));

/**
 * ScrollToTop component - Scrolls to top on route change
 * Disables smooth scrolling temporarily to prevent visible scroll animation
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    // scroll-behaviorを一時的に無効化
    const html = document.documentElement;
    const originalScrollBehavior = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';

    // スクロール位置をリセット
    window.scrollTo(0, 0);

    // 次のフレームでscroll-behaviorを復元
    requestAnimationFrame(() => {
      html.style.scrollBehavior = originalScrollBehavior;
    });
  }, [pathname]);

  return null;
};

/**
 * App component - Main application router
 * Implements requirements 2.1, 2.2, 2.7 for client-side routing
 */
const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:slug" element={<NewsArticlePage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
